exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".estimated-time{font-family:'Montserrat', sans-serif;display:flex;flex-direction:row;align-items:center;cursor:pointer}.estimated-time .clock{width:2.5em;height:2.5em;border-radius:50%;background-color:#ffffff;transform:translateX(50%);z-index:1}.estimated-time .clock svg{width:100%;height:100%}.estimated-time .time{padding:0.6rem 0.6rem 0.6rem 1.875rem;border:1.5px solid #D0D0D0;border-radius:2px;color:#1A242E;font-family:inherit;font-size:1.2em;line-height:1em}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/EstimatedTime/style.scss
// module id = 1450
// module chunks = 0